module.exports = __webpack_public_path__ + "img/bootstrap-reboot.ff69a2ab.svg";